/* istanbul ignore file */
import logger from './logger';
import location from './location';

export default [logger, location];
